module.exports = __webpack_public_path__ + "e5f6308c258dead7d5c95f05d3e3e431.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mgm-bg-5.jpg
// module id = 143
// module chunks = 0